function scrollbarWidth() {

  var div, width;

  div = document.createElement( 'div' );
  div.className = 'scrollbar-measure';
  document.body.appendChild( div );
  width = div.offsetWidth - div.clientWidth;
  document.body.removeChild( div );

  return width;
}

function scale() {

  var page = the( '[data-page]' );

  var w = page.offsetWidth || page.clientWidth;

  function basis( min ) {
    custom = Math.floor( 62.5 * w / ( min + scrollbarWidth() ) );
    document.documentElement.style.fontSize = custom + '%';
  }

  if      ( w < 608  ) basis( 320  )
  else if ( w < 912  ) basis( 608  )
  else if ( w < 1216 ) basis( 912  )
  else if ( w < 1520 ) basis( 1216 )
  else if ( w < 1824 ) basis( 1520 )
  else if ( w < 2128 ) basis( 1824 )
  else if ( w < 2432 ) basis( 2128 )
  else if ( w < 2736 ) basis( 2432 )
  else if ( w < 3040 ) basis( 2736 )
}

scale();

function clear( filter ) {

  if ( filter !== null ) {

    if      ( filter.tagName == 'INPUT'  ) filter.value = ''
    else if ( filter.tagName == 'SELECT' ) filter.value = 'all'

  }

}

function normalizeString( string ) {

  var normalized = string.toLowerCase();

  var map = {
    'à' : 'a',
    'á' : 'a',
    'â' : 'a',
    'ã' : 'a',
    'è' : 'e',
    'é' : 'e',
    'ê' : 'e',
    'ì' : 'i',
    'í' : 'i',
    'î' : 'i',
    'ò' : 'o',
    'ó' : 'o',
    'ô' : 'o',
    'õ' : 'o',
    'ù' : 'u',
    'ú' : 'u',
    'û' : 'u',
    'ü' : 'u',
    'ç' : 'c',
    '.' : ' ',
    ',' : '',
    '(' : '',
    ')' : '',
    '´' : '',
    '`' : '',
    '~' : '',
    '^' : '',
    '!' : '',
    '?' : '',
    'jr' : 'junior'
  }

  function escapeRegExp( unescaped ) {

    return unescaped.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$]/g, '\\$&')

  }

  var rx = new RegExp( escapeRegExp( Object.keys( map ).join( '|' ) ), 'gi' )

  normalized = normalized.replace( rx, function( match ) {

    return map[ match ]

  })

  normalized = normalized.replace(/  +/g, ' ')

  normalized = normalized.trim()

  return normalized

}

function noResultsChecker() {

  if ( the( '.list li[data-visible="true"]' ) ) {

  	the( '.list' ).dataset.results = 'true';

  } else {

  	the( '.list' ).dataset.results = 'false';

  }

}

function httpBuildQuery( options ) {

  var pairs = [];

  for ( var prop in options ) {
    if ( options.hasOwnProperty( prop ) ) {
      var key   = encodeURIComponent( prop );
      var value = encodeURIComponent( options[ prop ] );
      pairs.push( key + '=' + value );
    }
  }

  return pairs.join( '&' );

}

function scrollToElement( element, align, padding ) {

  align   = align   || 'center';
  padding = padding || 0;

  var px     = 0;
  var rect   = element.getBoundingClientRect();
  var offset = {

    top  : rect.top  + document.body.scrollTop,
    left : rect.left + document.body.scrollLeft

  };

  if ( align === 'top' ) {

    px = offset.top - padding;

  } else {

    var h = window.innerHeight || document.documentElement.clientHeight || document.getElementsByTagName( 'body' )[ 0 ].clientHeight;
    var eh = element.offsetHeight;

    if ( align === 'center' )
      px = offset.top - ( h / 2 ) + ( eh / 2 );

    else if ( align === 'bottom' )
      px = offset.top - h + eh + padding;
  }

  window.scroll( 0, px );

}

function findGetParameter( parameterName ) {
  var result = null,
      tmp = [];
  var items = location.search.substr(1).split("&");
  for (var index = 0; index < items.length; index++) {
      tmp = items[index].split("=");
      if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
  }
  return result;
}

function getOrder( voters, position ) {
  var order = 999 - voters;
  if ( Number( position ) ===  1 ) order = -1;
  if ( Number( position ) === 10 ) order = 1000;
  if ( Number( position ) ===  2 ) order = 1001;
  return order;
}

function setOrder( value, el ) {
  el.style[  '-webkit-order' ] = value;
  el.style[ '-ms-flex-order' ] = value;
  el.style[          'order' ] = value;
}

var delay = (function(){
  var timer = 0;
  return function(callback, ms){
    clearTimeout (timer);
    timer = setTimeout(callback, ms);
  };
})();

// polyfill for includes()

if ( !String.prototype.includes ) {

  String.prototype.includes = function( search, start ) {

    'use strict';

    if ( typeof start !== 'number' )
      start = 0;

    if ( start + search.length > this.length )
      return false;

    else
      return this.indexOf( search, start ) !== -1;

  }

}

// polyfill for closest() and matches()

(function (ElementProto) {
	if (typeof ElementProto.matches !== 'function') {
		ElementProto.matches = ElementProto.msMatchesSelector || ElementProto.mozMatchesSelector || ElementProto.webkitMatchesSelector || function matches(selector) {
			var element = this;
			var elements = (element.document || element.ownerDocument).querySelectorAll(selector);
			var index = 0;

			while (elements[index] && elements[index] !== element) {
				++index;
			}

			return Boolean(elements[index]);
		};
	}

	if (typeof ElementProto.closest !== 'function') {
		ElementProto.closest = function closest(selector) {
			var element = this;

			while (element && element.nodeType === 1) {
				if (element.matches(selector)) {
					return element;
				}

				element = element.parentNode;
			}

			return null;
		};
	}
})(window.Element.prototype);
